import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { dashboardQuotesList } from '../../store/services/shared';
import { STALE_TIMES } from 'src/utils/constants/queryConstants';
import { track } from '../../utils/telemetry';

const GetDashboardQuotesListData = (data: any) => {
  return dashboardQuotesList(data);
};

export const useGetDashboardQuotesListData = (data: any) => {
  return useQuery({
    queryKey: ['dashboardQuotes'],
    queryFn: async () => {
      try {
        return await GetDashboardQuotesListData(data);
      } catch (error) {
        track('GetDashboardQuotesListData  -- ERROR:', { error });
        throw error;
      }
    },
    staleTime: STALE_TIMES.THIRTY_MINUTES,
  });
};

